import React, { createContext, useEffect, useMemo, useState } from 'react';

import { AFFILIATE_LIST } from "../../domain/affiliate/AffiliateListData";

const AffiliateContext = createContext(null);
export default AffiliateContext;

const { Provider } = AffiliateContext;

const AffiliateProvider = (props) => {
  const [isAffiliateOutlink, setIsAffiliateOutlink] = useState(Boolean(sessionStorage.affiliate_outlink) || false);
  const [affiliateId, setAffiliateId] = useState(sessionStorage.utm_id || null);
  const [affiliateCampaign, setAffiliateCampaign] = useState(sessionStorage.utm_campaign || null);

  // 초기 로딩시 UTM 태그 파싱 및 저장
  useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    params.forEach((e, i) => {
      i === 'utm_id' && setAffiliateId(e);
      i === 'utm_campaign' && setAffiliateCampaign(e);
      sessionStorage.setItem(i, e);
    });
  }, []);

  // 제휴 쿠폰 코드 정보 저장
  const affiliateCouponCode = useMemo(() => {
    if (!affiliateId || !affiliateCampaign) return null;
    console.log('Finding affiliate info');
    const affiliateInfo = AFFILIATE_LIST.find(e => e.utm_id === affiliateId && e.utm_campaign === affiliateCampaign)

    if (isAffiliateOutlink || (affiliateInfo && (!affiliateInfo.requires_no_referrer || (affiliateInfo.requires_no_referrer && window.history.length === 1)))) {
      console.log('Affiliate outlink mode');
      setIsAffiliateOutlink(true);
    } else {
      console.log('Not affiliate outlink mode');
      setIsAffiliateOutlink(false);
    }

    return affiliateInfo ? affiliateInfo.code : null
  }, [affiliateId, affiliateCampaign]);

  // 아웃 링크가 아니거나 모드 해제시 UTM 정보 삭제
  useEffect(() => {
    if (isAffiliateOutlink) {
      sessionStorage.affiliate_outlink = 'true';
    } else {
      console.log('Clearing affiliate info');
      setAffiliateId(null);
      setAffiliateCampaign(null);
      sessionStorage.removeItem('affiliate_outlink');
    }
  }, [isAffiliateOutlink]);

  const context = {
    state: {
      isAffiliateOutlink,
      affiliateId,
      affiliateCampaign,
      affiliateCouponCode,
    },
    actions: {
      setIsAffiliateOutlink,
    },
  };

  return <Provider value={context}>{props.children}</Provider>;
};

export { AffiliateProvider };
